import React, { useState } from "react";
import { useToast } from "../../ToastProvider";
import Card from "./Card/Card";
import Header from "../../../Components/Header";
import "../Dashboard/index.scss";
import { useFetchQuery } from "../../../features/Group/groupSlice";
import GroupsIcon from "@mui/icons-material/Groups";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DescriptionIcon from "@mui/icons-material/Description";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ReportIcon from "../../Sidebar/ReportIcon";
import DynamicTable from "../../../Components/Table";
import { createSearchParams, useNavigate } from "react-router-dom";
import { useGetdashQuery } from "../../../features/Dashboard/dashboardSlice";
import YearFilter from "../../../Components/YearFilter/YearFilter";

const Dashboard = () => {
  const { showSuccess, showError } = useToast();

  const handleToast = () => {
    showError({
      title: "Success!",
      body: "Error",
    });
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState([]);
  const [rowData, setRowData] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { data: Dashdata = { data: [] }, error: dashErr, isLoading: dashLoad } = useGetdashQuery({ year: filters });
  console.log("DATADASH", Dashdata, dashErr, dashLoad);

  const { data = { data: [] }, error, isLoading, refetch } = useFetchQuery({ page: 1 });
  console.log("DATA", data, rowsPerPage, currentPage);

  const navigate = useNavigate();

  const cardsArr = [
    {
      icon: <GroupsIcon className='dashboard_card_icon' />,
      text: "Total Number Of Groups",
      groups: Dashdata?.groupCount,
      backgroundColor: "#493D9E",
    },
    {
      icon: <ApartmentIcon className='dashboard_card_icon' />,
      text: "Total Number Of Companies",
      groups: Dashdata?.companyCount,
      backgroundColor: "#8E1FB4",
    },
    {
      icon: <DescriptionIcon className='dashboard_card_icon' />,
      text: "Total Records Added",
      groups: Dashdata?.inputLayoutCount,
      backgroundColor: "#48A6A7",
    },
  ];

  const actionArr = [
    {
      name: "View Group",
      icon: <ReportIcon />,
      id: 1,
    },
  ];

  const handleMenuOptions = (rowData) => {
    setRowData(rowData);
    console.log("handleMenuOptions is clicked!", rowData);
  };

  const handleMenuItem = (val) => {
    if (val.id === 1) {
      navigate({
        pathname: "/super/report/list",
        search: `?${createSearchParams({ id: rowData?.id, grp: rowData?.groupId, grpname: rowData?.name })}`,
      });
    }
    console.log("handleMenuItem is clicked!");
  };

  const fields = [
    { id: "groupId", label: "Group ID", minWidth: 150, sortable: true },
    { id: "name", label: "Group Name", minWidth: 200, sortable: true },
    { id: "subAdminEmails", label: "Group Sub Admin", minWidth: 80, sortable: true },
    { id: "isActive", label: "Status", minWidth: 200, sortable: false },
    { id: "actions", label: "Actions", minWidth: 100, sortable: false },
  ];

  const handleShowMoreClick = () => {
    console.log("first");
    navigate("/super/report");
  };

  const handleFilter = (data) => {
    // console.log("DATAAA",data)
    const numArray = data.map(Number);
    setFilters(numArray);
  };

  const handleReset = () => {
    setFilters([]);
  };

  return (
    <div>
      <div className='dashboard_container'>
        <div className='dashboard_body'>
          <div className='dashboard_cards_filter'>
            <div className='dashboard_cards'>
              {cardsArr.map((card, index) => (
                <Card key={index} icon={card.icon} text={card.text} groups={card.groups} bgcolor={card.backgroundColor} />
              ))}
            </div>

            <YearFilter onFilterClick={handleFilter} onReset={handleReset} />
          </div>

          <div className='dashboard_body_table'>
            <Header
              title={"Latest Groups Added"}
              description={`${data?.data.length} Reports`}
              isSearchField={false}
              isCancel={false}
              isIcon={false}
              isBtn={false}
            />
            <DynamicTable
              columns={fields}
              rows={data?.data || []}
              isDash={true}
              isLoading={isLoading}
              dropMenuList={actionArr}
              handleAction={handleMenuOptions}
              handleMenu={handleMenuItem}
              isFooter={false}
            />
            {/* <button className='show_more' onClick={handleShowMoreClick}>
              See More
              <ChevronRightIcon className='right_icon' />
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
